import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Manifesto } from "@/components/landing/Manifesto";
import { Features } from "@/components/landing/Features";
import { Industries } from "@/components/landing/Industries";
import { EditorialMarquee } from "@/components/landing/EditorialMarquee";
import { Social } from "@/components/landing/Social";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  return (
    <main className="min-h-screen bg-[#050505] text-white antialiased">
      <Header />
      <Hero />
      <Manifesto />
      <Features />
      <Industries />
      <EditorialMarquee />
      <Social />
      <Footer />
    </main>
  );
}
